import { paymentProviders, paymentBrands } from '@app/constants/payment';
import RouterConstants from '@app/constants/router';

export function getPaymentProvider(brand) {
  switch (brand) {
    case paymentBrands.VISA:
    case paymentBrands.MASTERCARD:
      return paymentProviders.DATACASH;
    case paymentBrands.PAYPAL:
      return paymentProviders.PAYPAL;
    case paymentBrands.UNIFIED_PAYMENT:
      return paymentProviders.UNIFIED_PAYMENT;
    default:
      return 0;
  }
}

export function getPaymentParams(promoCode) {
  const paymentParams = {
    paymentData: {
      paymentBrand: paymentBrands.UNIFIED_PAYMENT,
      paymentProvider: getPaymentProvider(paymentBrands.UNIFIED_PAYMENT),
      returnUrl: window.location.origin + RouterConstants.PAYMENT_RESULT,
      policyValidation: true,
    },
  };

  if (promoCode) {
    paymentParams.voucher = promoCode;
  }

  return paymentParams;
}
